export default "__VITE_ASSET__1d8270ac__"